module.exports = __webpack_public_path__ + "img/LK.9401481c.svg";